import {getSearchCookie} from './cookies';

/**
 * @param {Date|null} date
 * @returns {string|null} The date string in ISO format (YYYY-MM-DD)
 */
const getDateString = (date) => date && date.toISOString().split('T')[0];

export function getDatesFromCookie(searchCookieValues) {
    const now = new Date();

    const {arrival, departure} = searchCookieValues;
    const arrivalMs = Date.parse(arrival);
    const departureMs = Date.parse(departure);

    const todayMs = Date.parse(getDateString(now));

    if (arrival && departure && arrivalMs >= todayMs && arrivalMs < departureMs) {
        return {
            arrivalDate: arrival,
            departureDate: departure
        };
    }

    return {
        arrivalDate: null,
        departureDate: null
    };
}

export function getTypeOfGuestFromCookie(cookieGuests, defaultNumber) {
    const guests = parseInt(cookieGuests, 10);

    if (isNaN(guests)) {
        return defaultNumber;
    }

    return guests;
}

export function getGuestsFromCookie(searchCookieValues) {
    const defaultChildren = 0;
    const defaultAdults = 0;
    const defaultPetIncluded = false;

    const {numberOfAdults, numberOfChildren, petIncluded} = searchCookieValues;

    const adults = getTypeOfGuestFromCookie(numberOfAdults, defaultAdults);

    if (adults === 0) {
        return {
            adults: defaultAdults,
            children: defaultChildren,
            petIncluded: defaultPetIncluded
        };
    }

    const children = getTypeOfGuestFromCookie(numberOfChildren, defaultChildren);

    return {
        adults,
        children,
        petIncluded: typeof petIncluded === 'string' ? petIncluded === 'true' : petIncluded
    };
}

export function getSearchValues(cookies) {
    const searchCookieValues = getSearchCookie(cookies);

    return {
        ...getDatesFromCookie(searchCookieValues),
        ...getGuestsFromCookie(searchCookieValues)
    };
}
